// extracted by mini-css-extract-plugin
export default {"icon":"TemplateIcon-module__icon--MU3jb","animatedBackground":"TemplateIcon-module__animatedBackground--_oERj"};